import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
	booleanAttribute,
	Component,
	inject,
	Input,
	TemplateRef
} from '@angular/core';
import {
	StandaloneActionButton,
	StandaloneActionsToolbarComponent
} from '@app/shared/standalone-actions-toolbar';
import { NbCardModule, NbDialogRef } from '@nebular/theme';
import { UntilDestroy } from '@ngneat/until-destroy';
import { of } from 'rxjs';
@UntilDestroy()
@Component({
	templateUrl: './empty-dialog.component.html',
	styleUrls: ['./empty-dialog.component.scss'],
	standalone: true,
	imports: [
		NbCardModule,
		NgClass,
		NgTemplateOutlet,
		StandaloneActionsToolbarComponent
	]
})
export class EmptyDialogComponent {
	@Input() leftButton: StandaloneActionButton = {
		text: 'UTILS.CANCEL',
		click: () => this.ref.close(),
		disabled$: of(false)
	};
	@Input() rightButton: StandaloneActionButton;
	@Input() dialogTemplate: TemplateRef<any>;
	// lasciato ad any perché customizzabile ed utilizzabile come si vuole nel template che viene passato dal padre
	@Input() data: any;
	@Input({ transform: booleanAttribute }) emptyToolbar = false;
	@Input() styleDialog: any;

	/**
	 * DI
	 */
	protected ref = inject(NbDialogRef<EmptyDialogComponent>);

	close() {
		this.ref.close();
	}

	// ngOnInit(): void {}
}
